import { useAppSelector } from '@common/hooks'

import type { IAccessState } from './access'
import { userLevelSelector } from './access'


export default function useAccessLevel(access: number): boolean {
  const featureFlags = useAppSelector(store => store.featureFlags)
  const common = useAppSelector(store => store.common)
  const level = userLevelSelector({
    featureFlags,
    common,
  } as IAccessState)
  return !!(level & access)
}
